import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    width: '100%'
  },
  paper: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
  }
}))

const HomeCard = ({ actions, children, subTitle, title }) => {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography gutterBottom variant='h5' component='h2'>
          {title}
        </Typography>
        <Typography className={classes.title} color='textSecondary' gutterBottom>
          {subTitle}
        </Typography>
        {children}
      </CardContent>

      {actions &&
        <CardActions>
          {actions}
        </CardActions>
      }
    </Card>
  )
}

export default HomeCard
